<template>
    <div class="introduction">
        <div class="introduction-title" ref="title">
          <div class="introduction-title-background" v-if="book.meta.Options.LargeSize">
            <img class="introduction-cover-image" v-if="book.meta.Options.CoverAsset && book.meta.Options.CoverAsset.Files" :src="book.meta.Options.CoverAsset.Files.Resized[2]">
          </div>
          <div class="introduction-title-page">
            <h1 v-html="book.meta.Options.InsideTitle"/>
            <h1 v-html="book.meta.Options.Subtitle"/>
            <a v-if="book.data.Sticker && book.data.Sticker.length && book.data.Sticker[0].Original"
              :href="book.data.Sticker[0].Captions[0]"
              target="_blank"
              class="introduction-title-sticker"
            >
              <img :src="book.data.Sticker[0].Original"/>
            </a>
            <h1 id="titleAuthor" v-html="book.meta.Options.Author"/>
          </div>
          <div class="introduction-title-preface">
            <div class="introduction-title-preface-content" :lang="$root.language == 0 ? 'de' : 'en'" v-html="book.meta.Options.Blurb"/>
          </div>
        </div>
        <div class="introduction-cover" ref="cover" v-if="!book.meta.Options.LargeSize">
          <img class="introduction-cover-image" v-if="book.meta.Options.CoverAsset && book.meta.Options.CoverAsset.Files" :src="book.meta.Options.CoverAsset.Files.Resized[2]">
        </div>
      </div>
</template>

<script>

export default {
  name: 'Title',
  props: [
    'bookData'
  ],
  data () {
    return ({
      book: this.bookData
    })
  }
}
</script>

<style lang="scss">

@import '../main';
.book-largesize {
    .introduction {
        color: white;
        &-title {
            top: 0px;
            position: relative;
            &-background {
                position: sticky;
                top: 0px;
                width: 100%;
                height: 0px;
                overflow: visible;
                &:before {
                  content: "";
                  width: 100%;
                  @include lvh(100);
                  position: absolute;
                  left: 0px;
                  top: 0px;
                }
                .introduction-cover-image {
                  position: absolute;
                }
            }
            &-preface {
              overflow: visible;
              @include lvh(100, 'min-height');
              &-content {
                position: sticky;
                margin-bottom: 0px;
                padding-bottom: 0px;
                top: var(--menuwidth-hidden);
              }
            }
        }
    }
}
.introduction {
    position: relative;
    &-title {
        top: 0px;
        box-sizing: border-box;
        background: var(--title-background-color);
        &-sticker {
          position: absolute;
          left: calc(12.5vw + var(--padding) + calc((75vw - var(--total-menuwidth) - var(--padding-20)) * var(--sticker-random-left)));
          top: calc((12.5 * var(--lvh-unit)) + var(--padding) + calc(((75 * var(--svh-unit)) - var(--padding-20)) * var(--sticker-random-top)));
          transform: translateX(-50%) translateY(-50%);
          mix-blend-mode: multiply;
          img {
            transition: all 0.25s;
            max-width: 25vw;
            max-height: calc(25 * var(--lvh-unit));
            width: auto;
            height: auto;
            transform: rotate(-25deg) scale(1);
            animation: pulsate 1.5s infinite;
            animation-play-state: paused;
            @include hover() {
              animation-play-state: running;
            }
            @keyframes pulsate {
              0% {
                transform: rotate(-25deg) scale(1);
                filter: brightness(1);
              }
              50% {
                transform: rotate(-25deg) scale(1.025);
                filter: brightness(1.2);
              }
              100% {
                transform: rotate(-25deg) scale(1);
                filter: brightness(1);
              }
            }
          }
        }
        &-page {
          @include svh(100, 'min-height');
          position: relative;
          margin-left: calc(var(--menuwidth-left));
          margin-right: calc(var(--menuwidth-right));
          transform: translateZ(0);
          z-index: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 0 var(--padding);
          box-sizing: border-box;
          h1 {
            font-size: var(--titlefontsize);
            text-transform: uppercase;
            font-weight: bold;
            text-align: center;
            line-height: 1.05;
            padding: 0;
            margin-top: calc(var(--titlefontsize) * -0.21);
            margin-bottom: calc(var(--titlefontsize) * -0.135);
            padding-top: var(--menuwidth-hidden);
            padding-bottom: var(--menuwidth-hidden);
            @include sm() {
                hyphens: auto;
            }
          }
        }
        &-preface {
          position: relative;
          top: 0px;
          z-index: 2;
          padding: calc(var(--menuwidth-hidden) * 0.8) calc(var(--menuwidth-right) + var(--padding)) calc(var(--menuwidth-hidden) * 0.8) calc(var(--menuwidth-left) + var(--padding));
          @include lvh(100, 'min-height');
          &-content {
            margin: auto;
            max-width: var(--blockwidth);
            text-align: justify;
            hyphens: auto;
            @include largefont;
            font-weight: bold;
            @include sm() {
              text-align: left;
            }
            position: sticky;
            top: var(--menuwidth-hidden);

          }
        }
    }
    &-cover {
        top: 0px;
        padding-left: var(--menuwidth-left);
        padding-right: var(--menuwidth-right);
        box-sizing: border-box;
        position: sticky;
        z-index: 3;
        transform: translateZ(0);
        backface-visibility: hidden;
        background: var(--title-background-color);
    }
    img.introduction-cover-image {
        margin: auto;
        display: block;
        width: 100%;
        object-fit: cover;
        object-position: 0% 0%;
        @include lvh(100, 'height');
        mix-blend-mode: multiply;
        z-index: -1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Title.vue